import React from "react";
import UploadModalContent from "../../components/dashboard/UploadModalContent";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { initializeUppy } from "../../components/common/UppyCommon";
import _ from "lodash";
import { Button } from "react-bootstrap";
import '@uppy/core/dist/style.css';
import '@uppy/url/dist/style.css';
import '@uppy/dashboard/dist/style.css';

import { changeUserAttribute } from "../../actions/auth";
import { addEventNameToEndpoint } from '../../utils/common';
import "./Uploader.scss";

const NOTIFY_URL = `${process.env.REACT_APP_TRANSLOADIT_NOTIFY_URL_UPLOAD}/items/v1/notifications`;
const CC_COMPANION_URL = process.env.REACT_APP_COMPANION_URL; // instead of Transloadit.COMPANION

class Uploader extends UploadModalContent {
  constructor(props) {
    super(props);
  };

  componentDidMount() {
    super.componentDidMount() && super.componentDidMount();
  }

  /**
   * On Add/import complete, fire the wrap up up of the uploader
   */
  skipToDashboard = () => {
    this.props.changeUserAttribute({ name: 'state', value: 'new user' });
    this.props.history.push('/dashboard');
  }


  onOpenUppyModal = async () => {
    const tokens = await this.props.Auth.currentSession();

    const options = {
      id: "uppyUploader",
      target: ".uppy-container",
      tenantId: _.get(this.props, "user.tenantId", ""),
      userId: _.get(this.props, "cognitoUser.username", ""),
      tokens: { accessToken: tokens.accessToken.jwtToken, idToken: tokens.idToken.jwtToken },
      cognitoUser: this.props.cognitoUser,
      collectionState: this.props.collectionState,
      items: this.props.items,
      path: this.props.path,
      getUrlFiles: this.getUrlFiles,
      setUrlFiles: this.setUrlFiles,
      Auth: this.props.Auth,
      Analytics: this.props.Analytics,
      onClose: this.skipToDashboard,
    };
    
    const uppy = initializeUppy(options);
  };

  render() {
    const isOwner = _.get(this.props, "cognitoUser.username", null) === _.get(this.props, "user.ownerId", null);
    const fromChecklist = _.get(this.props, 'history.location.pathname', '').includes('/add-import')

    return (
      <div className="uploader-container">
        <div className="uppy-container"></div>
        {!isOwner &&
          <Button
            className="btn-danger mt-4"
            sm="true"
            onClick={this.skipToDashboard}
          >
            <b>Skip to Dashboard</b>
          </Button>
        }
        {fromChecklist &&
          <Button
            className="btn-danger mt-4"
            sm="true"
            onClick={() => this.props.history.push('/onbboarding-checklist')}
          >
            <b>Back to checklist</b>
          </Button>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  Auth: state.auth.Auth,
  user: state.auth.tenant,
  cognitoUser: state.auth.cognitoUser,
  Analytics: state.auth.Analytics,
  accessToken: state.auth.cognitoUser ? state.auth.cognitoUser.signInUserSession.accessToken.jwtToken : null,
  identityToken: state.auth.cognitoUser ? state.auth.cognitoUser.signInUserSession.idToken.jwtToken : null,
});

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    changeUserAttribute
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Uploader);
